<template>
  <div>
    <div v-if="! editing" class="hovervisible-activator position-relative">
      <img :src="thumbnailUrl" :alt="$t('FILES.LINK_IMAGE_UNAVAILABLE')" style="width: 93px; max-height: 42px; object-fit: contain; object-position: left center">
      <div class="hovervisible-item export-hidden" style="position: absolute; top: 4px; right: 4px">
        <v-btn size="x-small" icon @click="$emit('update:editing', true)">
          <v-icon size="large">far fa-pencil-alt</v-icon>
        </v-btn>
      </div>
      <v-menu content-class="ml-2 rounded-sm" open-on-hover location="left" offset="8" transition="scale-transition" activator="parent">
        <div class="bg-surface" style="max-width: 310px">
          <img :src="thumbnailUrl" :alt="$t('FILES.LINK_IMAGE_UNAVAILABLE')" style="width: 100%;">
        </div>
      </v-menu>
    </div>
    <div v-else>
      <div class="pb-3 text-center">
        <div style="display: inline-block; position: relative">
          <croppa-vue-3 v-model="croppa" :placeholder="$t('ACCOUNT.SELECT_IMAGE')" :placeholder-font-size="16" :zoom-speed="7" :file-size-limit="20971520"
                        :show-remove-button="false" :quality="1" accept="image/*" :width="310" :height="140">
          </croppa-vue-3>
          <div v-show="chosenFile" style="position: absolute; bottom: 0; right: 0">
            <v-btn icon size="x-small" @click="removeImage()"><v-icon>far fa-trash-alt</v-icon></v-btn>
            <v-btn icon size="x-small" class="ml-1" @click="zoomOut()"><v-icon>far fa-search-minus</v-icon></v-btn>
            <v-btn icon size="x-small" class="ml-1" @click="zoomIn()"><v-icon>far fa-search-plus</v-icon></v-btn>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center">
        <v-btn v-if="! isExportImg" color="errorred" rounded @click="deleteThumbnail()">
          {{ $t('GLOBAL.DELETE') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="! chosenFile" color="primary" rounded @click="uploadThumbnail()">
          <v-icon class="mr-2">far fa-upload</v-icon>{{ $t('GLOBAL.SAVE') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import CroppaVue3 from '@/components/Reusables/CroppaVue3/cropper';

  export default {
    components: {
      CroppaVue3,
    },
    props: {
      planning: { type: Object, required: true },
      editing: { type: Boolean, default: false },
    },
    emits: ['update:editing'],
    data() {
      return {
        croppa: {},
      };
    },
    computed: {
      chosenFile() {
        return this.croppa.getChosenFile && this.croppa.getChosenFile();
      },
      isExportImg() {
        return ! this.planning.meta.imgurl || this.planning.meta.imgurl.startsWith(window.apiSrv.snapBaseUrl);
      },
      thumbnailUrl() {
        return this.subdomainLinkUrl(this.planning.meta.imgurl);
      },
    },
    methods: {
      removeImage() {
        this.croppa.remove();
      },
      zoomIn() {
        if (! this.chosenFile) return;
        this.croppa.zoomIn();
      },
      zoomOut() {
        if (! this.chosenFile) return;
        this.croppa.zoomOut();
      },
      uploadThumbnail() {
        if (! this.chosenFile) return;
        this.croppa.generateBlob((blob) => {
          if (! blob) return;
          blob.name = `${this.chosenFile.name.replace(/\..{3,4}$/, '')}.png`;
          window.apiSrv.uploadResource(blob).then((response) => {
            const id = response && response.data && response.data.file && response.data.file.id;
            if (! id) return Promise.reject(new Error('invalid upload'));
            return window.apiSrv.call('plannings', 'update', { id: this.planning.id, imageexport_name: response.data.file.url }).then(() => {
              this.planning.meta.imgurl = response.data.file.url;
              this.$emit('update:editing', false);
            });
          });
        }, 'image/png');
      },
      deleteThumbnail() {
        window.apiSrv.call('plannings', 'update', { id: this.planning.id, imageexport_name: "" }).then(() => {
          this.planning.meta.imgurl = "";
        });
        this.$emit('update:editing', false);
      },
      subdomainLinkUrl(url) {
        return clientConfig.subdomain && url?.startsWith('https://api.bubbleplan.net') ? `${url}?subdomain=${clientConfig.subdomain}` : url;
      },
    },
  };
</script>
